define('components/util/financeTreeUtil',[
    'jquery',
    'components/util/locale'
],function(
    jQuery, locale
){

    return {
      getParentTree: function (financeTree, name){
        if(!name){return;}
        var treeParent;
        function find(arr, n){
          if(treeParent){return treeParent;}
          for(var i=0; i<arr.length; i++){
            if(arr[i].id === n){
              treeParent = arr[i].parent;
            }

            if(arr[i].children){
              find(arr[i].children, n);
            }
          }
        }

        find(financeTree, name);
        return treeParent;
      },
      /**
       * divide a value by given dividevalue
       * @param {int} val value to divide
       * @param {integer} d
       */
      DivideValue: function(val, d, parentTree){
        if((!parseInt(val) || isNaN(val)) || (!parseInt(d) || isNaN(d))){
          return '';
        }
        val = parseInt(parseInt(val)/d);
        return val;
      },
      /**
       * multiply the value
       * @param {int} val the value
       * @param {int} m   multiply by this value
       */
      MultiplyValue: function(val, m){
        //replace ","decimal to "."
        val = locale.setNumeric2Server(val);

        if((!parseInt(val) || isNaN(val)) || (!parseInt(m) || isNaN(m))){
          return '';
        }
        val = parseInt(val)*m;
        return val;
      },
      /**
       * Check if the value is somewhere in the tree and has an ID
       */
      inTree: function(financeTree, val){
        var isValid = false;
        if(!val){return '';}

        function find(arr){
          if(isValid){return;}
          for(var i=0; i<arr.length; i++){
            if(arr[i].id === val){
              isValid = true;
              break;
            }

            if(arr[i].children){
              find(arr[i].children);
            }
          }
        }

        find(financeTree);
        return isValid;
      }
    };

});

